export { default as AnimatedBalloon } from './animatedBalloon'
export { default as AnimatedCloudA } from './animatedCloudA'
export { default as AnimatedCloudB } from './animatedCloudB'
export { default as AnimatedCloudC } from './animatedCloudC'



// WEBPACK FOOTER //
// ./src/components/animatedIcons/index.js